import { TextField } from '@mui/material';
import { WidgetProps } from '@rjsf/core';
import ReactPhoneInput from 'react-phone-input-mui';

export default function PhoneNumberWidget({ label, value, required, onChange, uiSchema }: WidgetProps) {
  return (
    <ReactPhoneInput
      value={value}
      defaultCountry={uiSchema?.defaultCountry ?? 'ca'}
      onChange={(e) => onChange(String(e))}
      component={TextField}
      inputExtraProps={{
        label: `${label} ${required ? ' *' : ''}`
      }}
    />
  );
}
